import type { EntryPointComponent } from 'react-relay';
import { createPageEntryPoint } from '@jira/platform__routing-create-route-entry-point/src/index.tsx';

import { MenuIdProjects } from '@jira/navigation-apps__constants/src/MenuIdProjects.tsx';
import { SidebarIdProjectSettings } from '@jira/navigation-apps__constants/src/SidebarIdProjectSettings.tsx';
import { getConsolidationStateResource } from '@jira/router-resources__eoc-tenant-info/src/getConsolidationStateResource.tsx';
import { LazyAtlassianNavigation } from '@jira/navigation-apps__atlassian-navigation/src/async.tsx';
import { GENERIC_PROJECT_HORIZONTAL_NAV } from '@jira/navigation-apps__horizontal-nav-selector/src/constants.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { getServiceDeskSettingsResources } from '@jira/router-resources__service-desk-common/src/getServiceDeskSettingsResources.tsx';
import { projectSettingsServicedeskProformaProjectFormsRoute } from '@jira/router-routes__project-settings-product-routes-service-desk-routes/src/projectSettingsServicedeskProformaProjectFormsRoute.tsx';
import { serviceProjectLayout } from '@jira/platform__layouts-service-project-layout/src/index.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import { JSResourceForUserVisible } from '@atlassian/react-async';
import type { Route } from '@atlassian/react-resource-router';
import ProformaProjectForms, {
	LazyProjectSettingsProformaProjectForms,
} from './ui/proforma-project-forms/index.tsx';

const projectSettingsServicedeskProformaProjectFormsPageEntryPoint = createPageEntryPoint({
	main: {
		root: JSResourceForUserVisible<EntryPointComponent<{}, {}, {}, {}>>(
			/* webpackChunkName: "async-project-settings-proforma-project-forms", jiraSpaEntry: "async-project-settings-proforma-project-forms" */ '@jira/spa-apps__project-settings-proforma-project-forms/src/ProformaProjectFormsSettingsPage.tsx',
			{ entryFsSsrLiftImportToModule: false },
		),
		getPreloadProps: () => ({}),
	},
});

export const projectSettingsServicedeskProformaProjectFormsRouteEntry: Route = createEntry(
	projectSettingsServicedeskProformaProjectFormsRoute,
	() => ({
		group: 'project-settings-servicedesk',

		// eslint-disable-next-line no-restricted-syntax
		component: fg('nike_entrypoint_migration_batch_2') ? undefined : ProformaProjectForms,

		entryPoint: () =>
			fg('nike_entrypoint_migration_batch_2')
				? projectSettingsServicedeskProformaProjectFormsPageEntryPoint
				: undefined,
		layout: serviceProjectLayout,

		navigation: {
			horizontal: GENERIC_PROJECT_HORIZONTAL_NAV,
			menuId: MenuIdProjects,
			sidebarId: SidebarIdProjectSettings,
		},

		resources: [...getServiceDeskSettingsResources(), getConsolidationStateResource()],
		forPaint: [LazyAtlassianNavigation, LazyProjectSettingsProformaProjectForms],
		perfMetricKey: 'forms-settings',

		bifrost: {
			bifrostGroup: 'shell-only',
		},
	}),
);
